import React from 'react';
import { useState, useEffect } from 'react'
import '../App.css';
import '../assets/customStyles/hashButtonStyle.css'
import { HashLink } from 'react-router-hash-link';
import AppBar from '@mui/material/AppBar';
import { Box as GBox } from 'grommet';
import { Button, Box } from '@mui/material'
import { Avatar, Header } from 'grommet';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import GitHubIcon from '@mui/icons-material/GitHub';
import EmailIcon from '@mui/icons-material/Email';
import Hamburger from 'hamburger-react';
import { Drawer as MuiDrawer } from '@mui/material';
import { useNavigate } from "react-router-dom";

//import logoWeb from "../assets/images/coloredInitialsLogo.png";
import logoWeb from "../assets/images/orangeCircleCutoutLogo.png";
import { navbarStyles } from '../assets/customStyles'

const useStyles = navbarStyles;

function NavigationBar() {
  const navigate = useNavigate();
  const [showDrawer, setShowDrawer] = React.useState((window.innerWidth < 1000) ? true : false);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [showContent, setShowContent] = useState(false);

  let hash = window.location.hash;

  useEffect(() => {
    let handleResize = () => {
      if (window.innerWidth < 1000) {
        setShowDrawer(true)
      }
      else {
        setShowContent(false)
        setShowDrawer(false);
    }
    }
    if(showContent)
    window.addEventListener('scroll', ()=>setShowContent(false))

    window.addEventListener('resize', handleResize)
  }, [showContent])

  const scrollWithOffset = (el) => {
    const yCoordinate = el.getBoundingClientRect().top + window.pageYOffset;
    const yOffset = -80;
    window.scrollTo({ top: yCoordinate + yOffset, behavior: 'smooth' });
  }

  return (
    <Box style={useStyles.parentBox} >
      <AppBar
        style={useStyles.appBar}
        elevation={0}
        position="fixed"
      >
        <div id='divBorder' style={useStyles.divBorder} >
          <Header
            className={showContent ? 'navbar-expand':'navbar'}
            elevation="small"
            direction="row"
            style={{ padding: 5, background: "#fbfbfb", margin: 20, borderRadius: 50, width: '90%', justifySelf: 'center', maxWidth: 1000, boxShadow: 'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px',paddingRight:10}}
          >
          
            <HashLink style={useStyles.removeLinkStyle} to="/#" scroll={el => scrollWithOffset(el)}>
              <Avatar
                src={logoWeb}
                size={"small"}
                onClick={() => navigate("#Home")}
                style={useStyles.avatar}
              />
            </HashLink>
           

            <div className='fade-in-menu' style={{ display: showContent ? 'flex' : 'none' ,position:'relative', justifyContent:'center', alignItems:'center',  color:'white', marginTop:50, maxWidth:'100%' }}>
              <GBox direction="column" style={{ alignItems: "center", justifyContent:'center',display:'flex', flexWrap:'wrap', width:'100%' }}>
              
                <HashLink style={useStyles.removeLinkStyle} to="/#" scroll={el => scrollWithOffset(el)}>
                  <Button size="large" color={(hash == '' || null) ? "secondary" : "primary"}>Home</Button>
                </HashLink>

                <HashLink style={useStyles.removeLinkStyle} to="/#Technicals" scroll={el => scrollWithOffset(el)}>
                  <Button size="large" color={hash == '#Technicals' ? "secondary" : "primary"}>Technicals</Button>
                </HashLink>
                <HashLink style={useStyles.removeLinkStyle} to="/#Projects" scroll={el => scrollWithOffset(el)}>
                  <Button onClick={()=>setShowContent(false)} size="large" color={hash == '#Projects' ? "secondary" : "primary"}>Projects</Button>
                </HashLink>
                <HashLink style={useStyles.removeLinkStyle} to="/#Experience" scroll={el => scrollWithOffset(el)}>
                  <Button size="large" color={hash == '#Experience' ? "secondary" : "primary"}>Experience</Button>
                </HashLink>
                <HashLink style={useStyles.removeLinkStyle} to="/#Education" scroll={el => scrollWithOffset(el)}>
                  <Button size="large" color={hash == '#Education' ? "secondary" : "primary"}>Education</Button>
                </HashLink>
                <a style={useStyles.removeLinkStyle} href="Resume.pdf" download={true}>
                  <Button
                    variant="contained"
                    color="secondary"
                    style={{borderRadius:20}}
                  >
                    Download CV
                  </Button>
                </a>
              </GBox>
            </div>

          
            <GBox direction="row" style={useStyles.connectHangBar}>
              <a target="_self" href="https://www.linkedin.com/in/jatinarora08/"><LinkedInIcon color="success" style={{ marginLeft: 10, marginRight: 10, color: "#1976D2" }} /></a>
              <a target="_self" href="https://github.com/jatinAroraGit"><GitHubIcon style={{ marginRight: 10, color: "#212121" }} color="primary" /></a>
              <a target="_self" href="mailto:jatin.arora@outlook.com"><EmailIcon style={{ marginRight: 10, color: "#EC0B43" }} color="primary" /></a>

            </GBox>
            {showDrawer ? (
              <>
                <div style={{ marginRight: 0, padding: 0, }} >
                    <Hamburger  duration="0.4" size="24" color="#EC0B43" direction="left" toggled={showContent} onToggle={() => setShowContent(!showContent)} />
                </div>
              </>
            )
              : (<Box style={{paddingTop:6.5}}>

                <HashLink smooth style={useStyles.removeLinkStyle} to="/#" scroll={el => scrollWithOffset(el)}>
                  <Button color={(hash == '' || null) ? "secondary" : "primary"}>Homes</Button>
                </HashLink>

                <HashLink smooth style={useStyles.removeLinkStyle} to="/#Technicals" scroll={el => scrollWithOffset(el)}>
                  <Button color={hash == '#Technicals' ? "secondary" : "primary"}>Technicals</Button>
                </HashLink>
                <HashLink smooth style={useStyles.removeLinkStyle} to="/#Projects" scroll={el => scrollWithOffset(el)}>
                  <Button color={hash == '#Projects' ? "secondary" : "primary"}>Projects</Button>
                </HashLink>
                <HashLink smooth style={useStyles.removeLinkStyle} to="/#Experience" scroll={el => scrollWithOffset(el)}>
                  <Button color={hash == '#Experience' ? "secondary" : "primary"}>Experience</Button>
                </HashLink>
                <HashLink smooth style={useStyles.removeLinkStyle} to="/#Education" scroll={el => scrollWithOffset(el)}>
                  <Button color={hash == '#Education' ? "secondary" : "primary"}>Education</Button>
                </HashLink>

                <a style={useStyles.removeLinkStyle} href="Resume.pdf" download={true}>
                  <Button
                    variant="outlined"
                    color="secondary"
                    style={{borderRadius:20}}
                  >
                    Download CV
                  </Button>
                </a>
              </Box>
              )}
          </Header>
          
        </div>
      </AppBar>

    </Box>
  )
}

export default NavigationBar;
